/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApplicationRef } from '@angular/core';
import { SessionContextResponseDto, ZvooveProblemDetails } from '@zvoove-market/api';
import { GlobalErrorHandler } from '../error/global-error-handler';

export interface BootstrapOptions {
  configUrl: string;
  prod: boolean;
  bootstrapFunc: () => Promise<void | ApplicationRef>;
}

let loginContext: SessionContextResponseDto | null = null;
export const getInitialLoginContext = () => loginContext;

export function bootstrapAngular({ configUrl, bootstrapFunc }: BootstrapOptions) {
  (async () => {
    // platformBrowserDynamic().bootstrapModule(AppModule) must stay in main.ts otherwise lazyloading breaks.
    setProgress('Loading user context...');
    loginContext = await loadLoginContext(configUrl);
    await bootstrapFunc();
  })().catch((e) => setProgressError(e));

  function setProgress(message: string) {
    const node = document.getElementById('js-boot-message');
    if (node) {
      node.textContent = message;
    }
  }

  function setProgressError(err: any) {
    console.error('bootstrap error', err);
    const errorNode = document.getElementById('js-boot-error');
    if (errorNode) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      errorNode.textContent = err.message || err;
    }
    const errorHandler = new GlobalErrorHandler();
    errorHandler.handleError(err);
  }
}

declare global {
  interface Window {
    tempConfigStorage?: any;
    tempUserStorage?: any;
  }
}

export async function loadLoginContext(baseUrl: string, mandantId?: string | null): Promise<SessionContextResponseDto> {
  const urlParams = new URLSearchParams(window.location.search);
  if (!mandantId) {
    mandantId = urlParams.get('mandantId');
  }
  const response = await fetch(`${baseUrl}/system/session/context`, {
    method: 'GET',
    headers: {
      'X-Mandant-Id': mandantId ?? '',
    },
    credentials: 'include',
  });

  try {
    const result = (await response.json().catch(() => ({ code: 'ResponseNotJson' }))) as SessionContextResponseDto | ZvooveProblemDetails;
    if ('code' in result) {
      console.error('Error loading login context', result);
      if (result.code == 'InvalidMandantId') {
        window.location.href = window.location.origin + '/mandant-select';
      }
      throw new Error(`${response.status} ${result.code}`);
    }
    return result;
  } catch (e) {
    throw new Error(`Could not load session context. Error: ${(e as Error).message}`);
  }
}
